module.exports = __webpack_public_path__ + "img/bg_question_des_2.2821f58c.jpg";